/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Step2_DescInputs */

const en_keyword_optimizer_step2_desc = /** @type {(inputs: Keyword_Optimizer_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI rewrites your existing bullets to naturally include missing keywords — never invents new experience.`)
};

const de_keyword_optimizer_step2_desc = /** @type {(inputs: Keyword_Optimizer_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI formuliert deine vorhandenen Stichpunkte um, damit fehlende Keywords natürlich einfließen — erfindet keine neue Erfahrung.`)
};

const fr_keyword_optimizer_step2_desc = /** @type {(inputs: Keyword_Optimizer_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IA reformule vos puces existantes pour intégrer naturellement les mots-clés manquants — sans inventer de nouvelle expérience.`)
};

const es_keyword_optimizer_step2_desc = /** @type {(inputs: Keyword_Optimizer_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La IA reformula tus viñetas existentes para incluir las palabras clave que faltan de forma natural — nunca inventa experiencia nueva.`)
};

const it_keyword_optimizer_step2_desc = /** @type {(inputs: Keyword_Optimizer_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'IA riscrive i tuoi punti esistenti per includere naturalmente le parole chiave mancanti — non inventa mai nuove esperienze.`)
};

const nl_keyword_optimizer_step2_desc = /** @type {(inputs: Keyword_Optimizer_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI herschrijft je bestaande opsommingen zodat ontbrekende zoekwoorden er natuurlijk in passen — verzint nooit nieuwe ervaring.`)
};

const pl_keyword_optimizer_step2_desc = /** @type {(inputs: Keyword_Optimizer_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI przeformułowuje istniejące punkty, by naturalnie uwzględnić brakujące słowa kluczowe — nigdy nie wymyśla nowego doświadczenia.`)
};

const fi_keyword_optimizer_step2_desc = /** @type {(inputs: Keyword_Optimizer_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekoäly muotoilee nykyiset kohtasi uudelleen niin, että puuttuvat avainsanat sisältyvät luonnollisesti — ei keksi uutta kokemusta.`)
};

const da_keyword_optimizer_step2_desc = /** @type {(inputs: Keyword_Optimizer_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI omskriver dine eksisterende punkter, så manglende nøgleord indgår naturligt — opfinder aldrig ny erfaring.`)
};

const sv_keyword_optimizer_step2_desc = /** @type {(inputs: Keyword_Optimizer_Step2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI skriver om dina befintliga punkter så att saknade nyckelord inkluderas naturligt — hittar aldrig på ny erfarenhet.`)
};

/**
* | output |
* | --- |
* | "AI rewrites your existing bullets to naturally include missing keywords — never invents new experience." |
*
* @param {Keyword_Optimizer_Step2_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_step2_desc = /** @type {((inputs?: Keyword_Optimizer_Step2_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Step2_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_step2_desc(inputs)
	if (locale === "fr") return fr_keyword_optimizer_step2_desc(inputs)
	if (locale === "es") return es_keyword_optimizer_step2_desc(inputs)
	if (locale === "it") return it_keyword_optimizer_step2_desc(inputs)
	if (locale === "nl") return nl_keyword_optimizer_step2_desc(inputs)
	if (locale === "pl") return pl_keyword_optimizer_step2_desc(inputs)
	if (locale === "fi") return fi_keyword_optimizer_step2_desc(inputs)
	if (locale === "da") return da_keyword_optimizer_step2_desc(inputs)
	if (locale === "sv") return sv_keyword_optimizer_step2_desc(inputs)
	return en_keyword_optimizer_step2_desc(inputs)
});